import { defineStore } from "pinia";
import axios from "axios";

export const useStatusStore = defineStore({
  id: "status",
  persist: true,
  state: () => ({
    orderData: null,
  }),
  actions: {
    setOrderData(order) {
      this.orderData = order;
    },
    getAllOrdersApi(data, token) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            process.env.VUE_APP_BASE_URL_API + "app/status/getAllOrders",
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    resendOrderApi(data, token) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            process.env.VUE_APP_BASE_URL_API + "app/status/resendOrder",
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    updateOrderStatus(data, token) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            process.env.VUE_APP_BASE_URL_API + "app/status/updateOrderStatus",
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
  },
});
